import imageCompression from "browser-image-compression";

export const compressImage = async (file) => {
  const options = {
    maxSizeMB: 2,
    maxWidthOrHeight: 800,
    useWebWorker: false, // Disabled due to CSP restrictions
  };
  return await imageCompression(file, options);
};

export const compressLogoImage = async (file) => {

  // Ensure file is never bigger than 10MB
  const maxSizeMB = 10;
  const maxWidthOrHeight = 2048; // Higher resolution for club logos

  const options = {
    maxSizeMB: maxSizeMB,
    maxWidthOrHeight: maxWidthOrHeight,
    useWebWorker: false, // Disabled due to CSP restrictions
    alwaysKeepResolution: false, // Allow compression to reduce resolution if needed
  };

  try {
    const compressedFile = await imageCompression(file, options);
    const base64String = await imageCompression.getDataUrlFromFile(compressedFile);

    if (typeof base64String === 'string' && base64String.startsWith('data:image')) {
      const base64Data = base64String.split(',')[1];
      
      return base64Data; // Return only the Base64 string
    } else {
      console.error('[ImageCompression] Failed to get valid Data URL from compressed file.');
      return null;
    }

  } catch (error) {
    console.error('[ImageCompression] Compression failed:', error);
    return null;
  }
};